import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { UserModel } from 'app/views/user/models/user.model';
import 'jquery-slimscroll';

declare let jQuery: any;

@Component({
    selector: 'psm-navigation',
    templateUrl: 'navigation.template.html'
})

export class NavigationComponent implements AfterViewInit, OnInit {
    public userInfo: UserModel;

    constructor(private router: Router, private userRepository: UserRepository, private authService: AuthService) {
    }

    public async ngOnInit() {
        let user = await this.authService.getCurrentUser();
        this.userInfo = await this.userRepository.get(user.uid);
    }

    public ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        if (jQuery('body').hasClass('fixed-sidebar')) {
            jQuery('.sidebar-collapse').slimscroll({
                height: '100%'
            });
        }
    }

    public activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    public logOut() {
        this.authService.logOut();
        this.router.navigateByUrl('/user/login');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/navigation/navigation.component.ts